export const USERDETAILS = "USERDETAILS";
export const CREDENTIALS = "CREDENTIALS";
export const ISLOADING = "ISLOADING";
export const CARTLIST = "CARTLIST";
export const LOGOUT = "LOGOUT";
export const POST = "POST";
export const PUT = "PUT";
export const PATCH = "PATCH";
export const GET = "GET";
export const THEMEKEY = 1;
export const DELETE = "DELETE";
export const ISDEV = true;
export const SETUSERTYPE = "SET_USER_TYPE";
export const SETUSERPROFILE = "SET_USER_PROFILE";
export const SETORGLOGO = "SET_ORG_LOGO";
export const SETGLOBALTHEME = "SET_GLOBAL_THEME";
export const UNREADMSGCOUNT = "UN_READ_MSG_COUNT";
export const SETMUSTACCEPTLEGAL = "SET_MUST_ACCEPT_LEGAL";

// for hide ui at development time
export const isDevelopment = true;

//paths
export const UserDetailsPath = "/manageUsers/user/userdetails";
export const ToolsInfoPath = "/FieldOfService/tools/info";
export const ScheduleService = "/FieldOfService/scheduleService";
export const RescheduleService = "/FieldOfService/reScheduleService";
export const ServiceInfoPath = "/FieldOfService/ServiceHistory/info";
export const ServiceEdit = "/FieldOfService/ServiceHistory/edit";
export const AddAToolPath = "/warehouse/add/addtools";
export const AddMultipleToolPath = "/warehouse/add/addmultipletools";
export const AddAToolCategoryPath = "/warehouse/add/addtoolcategory";
export const EditAToolCategoryPath = "/warehouse/edit/edittoolcategory";
export const categoryToolsPath = "/warehouse/category/tools";
export const DeletedToolsPath = "/warehouse/delete/deletedtools";
export const WarehouseToolDetail = "/warehouse/tooldetail";
export const EditAToolPath = "/warehouse/edit/edittool";
export const WarehouseDeleteToolPath = "/warehouse/deletetools";

export const TagOrder = {
  DRAFT: 0,
  SUBMIT: 1,
};

export const admin = "admin";
export const master = "master";
export const user = "user";
///warehouse/delete/deletetool
///warehouse/tooldetail
///warehouse/toollist
